<template>
  <div style="width: 100%; background-color: var(--grey_alpha)">
    <div class="view-content">
      <div id="about">
        <div class="about-fit">
          <div class="about-content">{{ $t("about.project.content") }}</div>
          <div class="about-title">
            <h2>{{ $t("about.tools.header") }}</h2>
          </div>
          <div class="about-content">{{ $t("about.tools.content") }}</div>
          <div class="about-title">
            <h2>{{ $t("about.corpus.header") }}</h2>
          </div>
          <div class="about-content">{{ $t("about.corpus.content") }}</div>
          <div class="about-title">
            <h2>{{ $t("about.team.header") }}</h2>
          </div>
          <div class="about-content">{{ $t("about.team.content") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  props: ["corpus"],
};
</script>
<style scoped>
h2 {
  color: #3d5c99;
}
#about {
  height: 100%;
  overflow: auto;
  text-align: justify;
  padding: 20px;
}
.about-title {
  margin-top: 2rem;
  height: 2rem;
  justify-content: center;
  background-color: var(--grey_dark1);
}
.about-title h2 {
  height: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  text-transform: uppercase;
  color: var(--white_grey);
  font-size: 1.5rem;
}
.about-content {
  padding-top: 10px;
}
@media only screen and (min-width: 768px) {
  .about-fit {
    width: 700px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/About.vue